import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fromTo'
})
export class FromToPipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {
    let char = args[0];
    let output = '';
    if (value) {
      let index = value.toString().indexOf(char);
      if (index != -1) {
        if (args[1] == true) {
          output = value.toString().substring(0, value.toString().indexOf(char))
        } else {
          output = value.toString().substring(value.toString().indexOf(char))
          if (output.length == 2) output = output + '0';
        }
      } else {
        if (args[1] == true) {
          output = value.toString();
        } else {
          output = '.00';
        }
      }
    }
    return output;
  }

}
